import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { MatButton } from '@angular/material/button';
import { MatCheckbox } from '@angular/material/checkbox';
import { CdkScrollable } from '@angular/cdk/scrolling';

export interface LinkLocationIpDialogData {
  location_name: string;
}

export interface LinkLocationIpDialogResult {
  link_ip: boolean;
}

@Component({
  selector: 'app-link-location-ip-dialog',
  templateUrl: './link-location-ip-dialog.component.html',
  styleUrl: './link-location-ip-dialog.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MatDialogActions, MatButton, MatCheckbox, FormsModule],
})
export class LinkLocationIpDialogComponent {
  private readonly dialog_ref = inject(MatDialogRef<LinkLocationIpDialogComponent, LinkLocationIpDialogResult>);
  readonly data = inject<LinkLocationIpDialogData>(MAT_DIALOG_DATA);

  readonly link_ip = signal(false);

  confirm(): void {
    this.dialog_ref.close({ link_ip: this.link_ip() });
  }

  cancel(): void {
    this.dialog_ref.close({ link_ip: false });
  }
}
